import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class DateService {
    months = ["", "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
    days = ["", "Lunes", "Martes", "Miercoles", "Jueves", "Viernes", "Sabado", "Domingo"];

    getMonth(value: number): string | null | undefined {
    if (!value || value == 0 || value > this.months.length - 1) { return "" };
    return this.months[value];
    }

    getDay(value: number): string | null | undefined {
        if (!value || value == 0  || value > this.days.length - 1) { return "" };
        return this.days[value];
    }

    getMeridiem(value: number): string | null | undefined {
        if (!value || value == 0) { return "a.m" };
        if(value < 12){
            return "a.m";
        }
        else if( value < 24){
            return "p.m";
        }
        return "";
    }


}

